import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import InfoRounded from '@mui/icons-material/InfoRounded'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export default function InfoClientModal(props) {
    const { client } = props;
    const [open, setOpen] = React.useState(false);

    const handleOpen = () => {
        if(client){
            setOpen(true);
        }        
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div>
            <Button variant='link' color='primary' size='small' onClick={handleOpen}><InfoRounded /></Button>
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                <div style={{display: 'flex', flexDirection: 'row', width: '100%'}}>
                    <div style={{display: 'flex', flexDirection: 'column', width: '50%'}}>
                        <strong>
                            Razón social:
                        </strong>
                        <span>{client ? client.name : ''}</span>
                    </div>                
                    <div style={{display: 'flex', flexDirection: 'row-reverse', width: '50%'}}>
                        <Button size='small' onClick={handleClose}>Cerrar</Button>
                    </div>
                </div>  
                <div style={{display: 'flex', flexDirection: 'row', width: '100%'}}>
                    <strong>
                            Código:
                    </strong>
                    <span>{client ? client.cod : ''}</span>
                </div>   
                <div style={{display: 'flex', flexDirection: 'row', width: '100%'}}>
                    <strong>
                            Correo comercial:
                    </strong>
                    <span>{client ? client.email_market : ''}</span>
                </div>    
                <div style={{display: 'flex', flexDirection: 'row', width: '100%'}}>
                    <strong>
                            Correo de facturación:
                    </strong>
                    <span>{client ? client.email_invoice : ''}</span>
                </div>      
            </Box>
        </Modal>
        </div>
    );
}